<template src="../templates/normal_fcont_110.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'

export default {
  name: 'app',
  data() {
    return {
      articleId: '110',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,
   FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadSmartPanel
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['110-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['110-2']}
    ]};

  }
};
</script>
<style />


